import React from "react";
import { FaArrowRight } from "react-icons/fa";

const foodItems = [
  {
    title: "Birthday Decoration",
    description:
      "Make your loved one's day extra special with vibrant balloon decor and custom setups that bring smiles and memories to life.",
    image: "/images/real/birthday-decoration.jpeg",
  },
  {
    title: "Cultural Event",
    description:
      "Celebrate tradition with elegance — from ethnic seating to colorful attire, we craft unforgettable cultural gatherings.",
    image: "/images/real/cultural-gathering.jpeg",
  },
  {
    title: "Romantic Surprise",
    description:
      "Add a spark to your love story with dreamy, balloon-filled romantic setups designed for proposals, anniversaries, and surprises.",
    image:
      "https://secondhomemds.com/wp-content/uploads/elementor/thumbs/3-2-qdh3w36hklghfwqlzoqckiluqgbk1ev0xwwv3f5or8.png",
  },
  {
    title: "Traditional Dining",
    description:
      "Enjoy authentic Indian meals in a rustic setup perfect for family functions, village-themed events, and traditional experiences.",
    image: "/images/real/traditional-dining-hall.jpeg",
  },
];

export default function OurServices() {
  return (
    <div className="py-16 px-4 md:px-10 bg-white">
      <div className="text-center mb-12">
        <h5 className="text-primary-dark font-semibold uppercase tracking-widest text-sm mb-2 font-serif">
          What We Offer
        </h5>
        <h1 className="font-display text-4xl font-bold text-gray-800">Our Services</h1>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-4 max-w-6xl mx-auto">
        {foodItems.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-3xl shadow-[0px_0px_10px_0px_#00000024] p-3 text-center transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl group"
          >
            <img
              src={item.image}
              alt={item.title}
              className="rounded-3xl mx-auto w-full h-[200px] object-cover transition-all duration-300 group-hover:scale-105"
            />
            <h3 className="mt-6 text-xl font-bold truncate overflow-hidden whitespace-nowrap ">
              {item.title}
            </h3>
            <p className="text-sm text-gray-600 mt-2">{item.description}</p>
            <div className="mt-6 flex justify-center">
              <button className="w-8 h-8 rounded-full bg-primary text-ink flex items-center justify-center hover:bg-primary-dark hover:text-white transition">
                <FaArrowRight size={14} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
